document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    if (
      document.querySelector('.appstle_tooltip_wrapper') &&
      document.querySelector('.appstle_subscribe_save_text')
    ) {
      clearInterval(interval);

      // move tooltip inside the widget
      let tooltip = document.querySelector('.appstle_tooltip_wrapper');
      let subscribeTitle = document.querySelector(
        '.appstle_subscription_radio_wrapper .appstle_radio_label'
      );
      let poweredFooter = document.querySelector('.appstle_tooltip_appstle');
      poweredFooter.remove();
      tooltip.innerHTML += `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16Z" fill="#818181"/>
      <path d="M8 8V11" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8 5H8.01" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      `;
      subscribeTitle.append(tooltip);

      // show text below the widget
      let appstleWidget = document.querySelector('.appstle_sub_widget');
      let buyButtonsBlock = document.querySelector('.block-buy_buttons');
      let elements = document.querySelectorAll(
        "[data-show-below-appstle='true']"
      );
      elements.forEach((element) => {
        appstleWidget.append(element);
      });
    }
  }, 100);
});
